<kiwi-decision-content class="cell-block-y winesPurchasing" (saved)="save()">
    <div class="cell auto grid-y" *ngIf="decision">
        <fieldset class="cell shrink">
            <legend [i18nKey]="'decisions.menu.wine.available.number'"></legend>
            <table class="_tableColor">
                <tbody>
                <tr class="_titlePartTable">
                    <td></td>
                    <td [width]="100" class="text-center"[i18nKey]="'common.quality'"></td>
                    <td [width]="200" class="text-center"[i18nKey]="'decisions.menu.purchasing.prices.excluding.taxes'"></td>
                    <td [width]="200" class="text-center"[i18nKey]="'decisions.menu.wine.available.number'"></td>
                    <td [width]="200" class="text-center"[i18nKey]="'decisions.menu.wine.stock'"></td>
                    <td [width]="200" class="text-center"[i18nKey]="'decisions.menu.wine.wacu'"></td>
                </tr>

                <tr *ngFor="let wineName of decision.winesPurchases | keys">
                    <td>{{'menu.' + wineName | translate}}</td>
                    <td [width]="100">
                        <input [(ngModel)]="decision.winesPurchases[wineName].quality"
                               type="number"
                               min="{{decision.minQuality}}"
                               max="{{decision.maxQuality}}"
                               [name]="wineName + 'Quality'"
                               (ngModelChange)="onQualityChange(wineName)"
                               [disabled]="decisionsReadonly"/></td>
                    <td [width]="200" class="text-center">{{decision.winesPurchases[wineName].purchasingPriceExcludingTax | number:'1.2'}}</td>
                    <td [width]="200" class="text-center">
                        <kiwi-number-input [(ngModel)]="decision.winesPurchases[wineName].purchasedNumber"
                               min="{{decision.minPurchasedNumber}}"
                               max="{{decision.maxPurchasedNumber}}"
                               (ngModelChange)="onPurchasedNumberChange(wineName)"
                               [name]="wineName + 'PurchasedNumber'"
                               [disabled]="decisionsReadonly">
                        </kiwi-number-input>
                    </td>
                    <td [width]="200" class="text-center">{{decision.winesPurchases[wineName].stock}}</td>
                    <td [width]="200" class="text-center">{{decision.winesPurchases[wineName].wacu | number:'1.2'}}</td>
                </tr>
                </tbody>
            </table>
        </fieldset>

        <kiwi-score-image class="cell shrink _horizontalView"
                          [imgQualityClass]="imgClass"
                          [scores]="scores"
                          [imgType]="'_winesPurchasing'"></kiwi-score-image>

        <kiwi-spacer [size]="32"></kiwi-spacer>
    </div>
</kiwi-decision-content>
